import React, { FC, useEffect, useState } from 'react';
import { graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useInView } from 'react-intersection-observer';
import { m, useAnimation } from 'framer-motion';
import Section from '../../../components/Section/Section';
import { ChartTitle, Content } from './styled';
import { slideInLeft, slideInRight } from '../../../data/animations';

const Charts: FC<Queries.ChartsFragment> = ({ charts }) => {
  const { ref, inView } = useInView();
  const control = useAnimation();
  const [viewed, steViewed] = useState(false);

  useEffect(() => {
    if (inView) {
      control.start('visible');
      steViewed(true);
    } else {
      if (viewed) return;
      control.start('hidden');
    }
  }, [control, inView, viewed]);

  return (
    <Section ref={ref}>
      <Content>
        {charts?.map((chart, idx) => (
          <m.div
            key={chart?.title}
            style={{ gridArea: `a${idx}` }}
            variants={idx === 0 ? slideInLeft : slideInRight}
            initial="hidden"
            animate={control}
          >
            <ChartTitle>{chart?.title}</ChartTitle>
            {chart?.image?.childImageSharp?.gatsbyImageData && (
              <GatsbyImage
                image={chart?.image?.childImageSharp?.gatsbyImageData}
                alt={chart?.title || ''}
              />
            )}
          </m.div>
        ))}
      </Content>
    </Section>
  );
};

export const query = graphql`
  fragment Charts on Json {
    charts {
      title
      image {
        childImageSharp {
          gatsbyImageData
        }
      }
    }
  }
`;

export default Charts;
